import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import StyledButton from "../components/StyledComponents/StyledButton";
import { useIdentityTokenVerificationMutation } from "../services/apis";
import StyledText from "../components/StyledComponents/StyledText";
import SuccessIcon from "../assets/svgIcons/SuccessIcon";
import AppOutlet from "../components/AppOutlet";

const IdentityVerification = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [token, setToken] = useState("");
  const [loading, setLoading] = useState("");
  const [verified, setVerified] = useState(false);
  const [verifyIdentity, { error }] = useIdentityTokenVerificationMutation();

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const tokenFromParams = queryParams.get("token");
    if (tokenFromParams) {
      setToken(tokenFromParams);
    } else {
      toast.error("Token not found!");
      navigate("/login");
    }
  }, [location.search]);

  useEffect(() => {
    setLoading(true);
    const fetchData = async () => {
      if (token) {
        try {
          await verifyIdentity(token);
          setVerified(true);
        } catch (error) {
          toast.error("Error verifying Identity. Please try again.");
          navigate("/login");
        } finally {
          setLoading(false);
        }
      }
    };
    setTimeout(() => fetchData(), 1500);
  }, [token, verifyIdentity, navigate]);
  useEffect(() => {
    if (error) {
      toast.error("Error verifying Identity. Please try again.");
      navigate("/login");
    }
  }, [error, navigate]);

  if (loading) {
    return (
      <AppOutlet>
        <div className="d-flex justify-content-center">
          Please wait, redirecting...
        </div>
      </AppOutlet>
    );
  }

  if (verified) {
    return (
      <AppOutlet>
        <div className="p-md-5 md-md-5 mt-2 pt-5">
          <div className="d-flex align-items-center flex-column justify-content-center p-2 p-md-5 m-2 md-md-5">
            <StyledText color="primary">
              <SuccessIcon className="px-4 px-md-0" />
            </StyledText>

            <StyledText
              $fontSize="1.1rem"
              $fontWeight="600"
              className="my-4 mt-md-5"
            >
              Identity verification
            </StyledText>
            <StyledText
              $fontSize="0.9rem"
              className="mb-3 mb-md-4 text-center"
              color="textColor"
            >
              Your identity has been verified successfully.
            </StyledText>
            <StyledButton
              _variant="primaryGradiant"
              className="d-flex align-items-center mt-3 px-5"
              onClick={() => navigate("/login")}
            >
              <StyledText $fontSize="0.9rem" $fontWeight="600" color="white">
                Go to Login Page
              </StyledText>
            </StyledButton>
          </div>
        </div>
      </AppOutlet>
    );
  }

  return <></>;
};

export default IdentityVerification;
